import React from "react";
import BesiktasSidebar from "../Sidebar/BesiktasSidebar";
import BesiktasOtherServices from "../ServiceAreas/BesiktasServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BesiktasIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BEŞİKTAŞ HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Beşiktaş’ta halı ve koltuklarınız için sunduğumuz profesyonel temizlik hizmetleri ile
            evinizde hijyenik ve sağlıklı bir yaşam alanı oluşturuyoruz. Yoğun iş temposuna sahip
            bireyler için pratik ve güvenilir çözümler sunan ekibimiz, temizlik sürecinin her
            aşamasında maksimum özen göstermektedir.
          </p>

          <p>
            Halılarınız, modern tam otomatik makinelerle yıkanırken, koltuklarınız yerinde veya
            fabrikada buharlı ve organik temizlik ürünleriyle arındırılır. Kullandığımız ürünler
            insan sağlığına dost olup, evcil hayvanlar için de tamamen güvenlidir.
          </p>

          <p>
            <strong>Beşiktaş bölgesinde sunduğumuz avantajlı hizmetler:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz adresten alım ve zamanında teslimat</li>
            <li>Organik ve antibakteriyel temizlik çözümleri</li>
            <li>Yerinde koltuk yıkama ve buharlı dezenfeksiyon</li>
            <li>Leke çıkarma garantili hizmet</li>
            <li>Perde, yorgan, battaniye yıkama hizmetleri</li>
            <li>48 saat içinde hızlı ve güvenilir teslimat</li>
          </ul>

          <p>
            Levent, Etiler, Ortaköy, Arnavutköy, Gayrettepe, Balmumcu gibi Beşiktaş’ın tüm mahallelerine
            aynı gün içerisinde ücretsiz servis sağlıyoruz. Mobil araçlarımız sayesinde hızlı
            ve güvenli teslimatla temizlik ürünlerinizi kapınızdan alıyor, tertemiz şekilde geri getiriyoruz.
          </p>

          <p>
            Halılar, profesyonel ön toz alma işlemi sonrasında uygun programla yıkanır ve steril
            ortamda kurutulur. Koltuklar ise kumaş türüne göre özel makinelerle hassas bir şekilde temizlenir.
          </p>

          <p>
            Siz de Beşiktaş bölgesinde hijyenik ve garantili temizlik hizmeti arıyorsanız,
            bizimle iletişime geçin. Fiyat bilgisi almak veya sipariş oluşturmak için web
            sitemizi ziyaret edebilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <BesiktasSidebar />
          <BesiktasOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BesiktasIntro;
